import React, { useState } from "react";
import Button from "@mui/material/Button";
import "../Login/loginScreen.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_API_URL } from "../../services/config"; // import base url
import { toast } from "react-toastify";
import  bgImage  from "./fbg1.svg";
import { ReactComponent as Floato } from "./fbg2.svg";
import { ReactComponent as IC } from "./icons.svg";
import { useForm } from "react-hook-form";
import SVGIcon from "../../components/DynamicIcon";
import './forgotPassword.css';
import { showSuccessToast } from "../../shared/CustomToast/customtoast";

const ForgotPassword = () => {
  const navigateTo = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const backToLoginHandler = () => {
    navigateTo("/");
  };

  const onSubmit = (data) => {
    const _email = data.email;
    let forgotPasswordData = {};
    forgotPasswordData.email = _email;
    setIsLoading(true);
    axios.put(`${BASE_API_URL}/api/v1/user/forgetPassword`, forgotPasswordData)
      .then((response) => {
        if (response.status === 200) {
          showSuccessToast(response?.data?.message);
          navigateTo("/");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Apologies for the inconvenience. We are currently addressing an unexpected error.", { autoClose: 5000 });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="page-container-forgotpassword">
      <div className="image-section-forgotpassword"style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '100vh', 
          width: '100%' 
        }}>
        <Floato className='floating-image '/>
        <IC className='icons'/>
      </div>


      <div className="forgot-password-form-section" style={{ flex: '1', height: '100vh' }}>
        <div >
          <div className="login_content_main" style={{ padding: "0px" }}>
            <div className="login_content">
              <div className="forgot_password_main">
                <div className="forgot_password_text">Forgot Password?</div>
                <div className="forgot_password_content">
                  Enter the email address associated with your account and we'll
                  send you a link to reset your password
                </div>
              </div>
              <form
                className="forgot-password-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="login-form-group">
                  <i className="input-icon">
                    <SVGIcon name="email" />
                  </i>
                  <input
                    id="email"
                    name="email"
                    className="login-form-field"
                    placeholder="Email"
                    {...register("email", { required: true })}
                    autoComplete="email"
                  />
                </div>
                <div className="back-to-login" onClick={backToLoginHandler}>
                  <span>Back to Login</span>
                </div>
                <p className={`error ${errors.email ? "active" : ""}`}>
                  Email is required.
                </p>
                <div className="forgot_sent_button forgot_password_sent_button">
                  <Button
                    type="submit"
                    variant="contained"
                    className="login_button"
                    disabled={isLoading}
                    sx={{
                      mt: 5,
                      mb: 2,
                      borderRadius: "5px",
                      border: "1px solid var(--primary-color)",
                      display: "block",
                      margin: "0 auto",
                      textTransform: "none",
                      backgroundColor: "var(--primary-color)",
                      padding: "8px 61px 8px 60px",
                      "&:hover": {
                        backgroundColor: "var(--primary-color)",
                      },
                    }}
                  >
                    <span className="login_button_text">{isLoading ? "Sending..." : "Send"}</span>
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default ForgotPassword;
